import React from 'react';
import styles from './Projects.module.css';
import Project from '../Project/Project';
import projectsArray from '../../common/data/projects/projects';

const Projects = () => {
    return (
        <div id="projects" className={styles.container}>
            <h2 className={styles.header}>01. Projects</h2>
                <div className={styles.projectsContainer}>
                {
                    projectsArray.map(p => (
                            <Project 
                                key={p.name} 
                                name={p.name} 
                                desc={p.desc} 
                                visit={p.visit ? p.visit : null}
                                youTube={p.youTube ? p.youTube : null}
                                scanQr={p.scanQr}
                                code={p.code}
                                role={p.role}
                                tools={p.tools}
                                date={p.date}
                            />
                    ))
                }
                </div>
        </div>
    )
}

export default Projects;
